<div class="question-wrapper-number vertical-view-radio" *ngIf="displayMode == 'Vertical'">
  <div class="div-content sentence-align">
    <ng-component class="editor-question" [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
  </div>

  <div class="example-margin example-margin2 vertical">
    <div class="stars-block" [ngClass]="questions?.questionsdisplayoptions == 'Horizontal' ? '': 'vertical-view d-block'">
      <div class="radio-container">
        <div *ngFor="let item of numberOfOption; let i = index" class="radio-options">
          <mat-radio-button disabled></mat-radio-button>
          <div class="stars">{{item.optionId}}</div>
        </div>
      </div>
      <div class="vertical-progress">
        <span>{{questions.ratinglow}}</span>
        <span>{{questions.ratinghigh}}</span>
      </div>
    </div>
  </div>
</div>

<div class="question-wrapper-number horizontal-view-radio" *ngIf="displayMode == 'Horizontal'">
  <div class="col-w-40">
    <div class="div-content">
      <ng-component class="editor-question"
        [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
    </div>
  </div>
  <div class="col-w-60">
    <div class="example-margin example-margin2 horizontal">
      <div class="stars-block">
        <div *ngFor="let item of numberOfOption; let i = index" class="radio-options">
          <div class="stars text-center">{{item.optionId}}</div>
          <mat-radio-button disabled></mat-radio-button>
        </div>
      </div>
      <div class="horizontal-view">
        <span class="horizontal-wrap label-1">{{questions.ratinglow}}</span>
        <span class="horizontal-wrap label-2">{{questions.ratinghigh}}</span>
      </div>
    </div>
  </div>
</div>
